import {
  Component,
  HostBinding,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLinkActive,
  RouterLink,
} from '@angular/router';
import { Menu, MenuChildrenItem, MenuService } from '@core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgTemplateOutlet, AsyncPipe, CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { MatTabsModule } from '@angular/material/tabs';
import { FeatherModule } from 'angular-feather';

export interface TopmenuState {
  active: boolean;
  route: string;
}

@Component({
    selector: 'app-topmenu',
    templateUrl: './topmenu.component.html',
    styleUrls: ['./topmenu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatTabsModule,
        NgxPermissionsModule,
        MatButtonModule,
        RouterLinkActive,
        RouterLink,
        NgTemplateOutlet,
        MatIconModule,
        AsyncPipe,
        TranslateModule,
        FeatherModule,
        CommonModule,
    ]
})
export class TopmenuComponent implements OnDestroy {
  @HostBinding('class') class = 'topmenu';

  menu$ = this.menu.getAll();

  buildRoute = this.menu.buildRoute;

  menuList: Menu[] = [];
  menuStates: TopmenuState[] = [];

  private menuSubscription = Subscription.EMPTY;
  private routerSubscription = Subscription.EMPTY;

  constructor(private menu: MenuService, private router: Router, private permissionsService: NgxPermissionsService) {
    this.menuSubscription = this.menu$.subscribe((res) => {
      this.menuList = res;
      this.menuList.forEach((item) => {
        this.menuStates.push({
          active: this.router.url.split('/').includes(item.route),
          route: item.route,
        });
      });
    });
  }

  getFirstAccessibleChild(children: MenuChildrenItem[]): MenuChildrenItem {
    const grants = Object.keys(this.permissionsService.getPermissions() || {});
    const accessible = children.find((child) => {
      const perms = child.permissions;
      if (!perms) return true;
      const only = perms.only ? (Array.isArray(perms.only) ? perms.only : [perms.only]) : undefined;
      const except = perms.except ? (Array.isArray(perms.except) ? perms.except : [perms.except]) : undefined;
      if (only && only.length > 0) return grants.some((r) => only.includes(r));
      if (except && except.length > 0) return !grants.some((r) => except.includes(r));
      return true;
    });
    return accessible ?? children[0];
  }

  ngOnDestroy() {
    this.menuSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }

  onRouteChange(rla: RouterLinkActive, index: number) {
    this.routerSubscription.unsubscribe();
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.menuStates.forEach((item) => (item.active = false));
        setTimeout(() => (this.menuStates[index].active = rla.isActive));
      });
  }
}
